

import { Component, OnInit, OnDestroy, HostListener, Input, ElementRef,AfterViewInit, Output, EventEmitter } from '@angular/core';
import { VgAPI, VgControlsHidden } from 'videogular2/core';
import { Observable, Subscription, combineLatest, Subject, from } from "rxjs";
import { FsDocument, FsDocumentElement, CustomWindow } from '../../../interfaces/fullscreen.type';
import { AppComponent } from '../../../app.component';
import { UnlServiceService } from "../../../services/unl-service.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Router, NavigationEnd, ActivatedRoute, ActivationEnd, RouterEvent, NavigationStart, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate
} from "@angular/router";
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { VideoPopupService } from 'src/app/services/cp-dc/video-popup.service';
import { Ad } from 'src/app/services/cp-dc/cp-dc.service';
@Component({
  selector: 'app-video-inline',
  templateUrl: './video-inline.component.html',
  styleUrls: ['./video-inline.component.scss'],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class VideoInlineComponent implements OnInit, AfterViewInit {
  location: Location;
  adtagUrl: string;
  twindow = window as any;
  api;
  subscriptions: Subscription[] = [];
  videooBject: object;
  videosrc: string;
  videotitle
  vidCatname
  videolink
  overLayT: boolean = false;
  overLayPause: boolean = false;
  overLayPlay: boolean = false;
  isPortrait = true;
  conPP: boolean;
  nodeId: any;
  autoplayboolean: boolean = true;
  ismuted: boolean = true;
 // add: Ad
  _iOSDevice: boolean = false;
  datadomain: string = "";
  @Input() add: Ad = null;
  @Output() videoEnded = new EventEmitter<void>();
  private observer: IntersectionObserver;
  private playedOnce = false;
  constructor(private controlsHidden: VgControlsHidden, private app: AppComponent,
    private unlServiceService: UnlServiceService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private ngNavigatorShareService: NgNavigatorShareService,
    private videoPopupService: VideoPopupService,
    private elementRef: ElementRef,
    location: Location) {
    this.datadomain = this.unlServiceService.basepath;
    // this._iOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
    this.location = location;
    router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        this.videosrc = null;
        const routeParams = this.activeRoute.snapshot.params;
        this.nodeId = routeParams.nodeId;
        this.ngNavigatorShareService = ngNavigatorShareService;
      }
    });
  }
  adsInt() {
  }
  ngOnInit() {
    this.videoLoader();

  }

  videoLoader() {
    const videoElement = this.elementRef.nativeElement.querySelector('video');
    if (videoElement) {
      videoElement.muted = true;
      videoElement.volume = 0;
      this.ismuted = true;
    }
    this.twindow.my = {};
    this.twindow.my.unlvideo = this.twindow.my.unlvideo || {};
    this.twindow.my.unlvideo.toggleScrn = this.setFullScreen.bind(this);
  }


  toggleMute() {
    const videoElement = this.elementRef.nativeElement.querySelector('video');
    if (videoElement) {
      this.ismuted = !this.ismuted;
      videoElement.muted = this.ismuted;
      this.api.volume = this.ismuted ? 0 : 1;
    }
  }
  

  togglePlay(e: any) {
    if (e.target.id === "muteButton") { return; }
    if (this.api) {
      if (this.api.state === 'playing') {
        this.api.pause();
      } else {
        this.api.play();
      }
    }
  }
  onPlayerReady(api: VgAPI) {
    this.api = api;
    this.api.volume = 0;
    console.log(this.api);
    var vid = document.getElementById("vgphome");
    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(
      () => {

      }
    );
    // this.api.fsAPI.toggleFullscreen(vid);
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
      () => {
        // Set the video to the beginning
        this.api.getDefaultMedia().currentTime = 0;
      }
    );

    /*this.api.getDefaultMedia().subscriptions.startAds.subscribe(() => {
     alert("test")
    });*/
    this.api.getDefaultMedia().subscriptions.pause.subscribe(() => {
      this.overLayT = false;
    })

    this.api.getDefaultMedia().subscriptions.play.subscribe(() => {
      this.overLayT = true;
      // setTimeout(()=>{ this.overLayT=false}, 4090)
    })
    this.api.getDefaultMedia().subscriptions.progress.subscribe(() => {
      this.conPP = false;
    })
    screen.orientation.onchange = function () {
      /* logs 'portrait' or 'landscape' */
      console.log(screen.orientation.type.match(/\w+/)[0]);
      var t = screen.orientation.type.match(/\w+/)[0];
      var elem = document.getElementById("vgphome");
      function tFullscreen() {
        this.toggleFullScreen()
      }
      try {
        var my: any;
        if (t == "landscape") {
          try {
            window["my"].unlvideo.toggleScrn(true);
          } catch (e) {

          }
        } else if (t == "portrait") {
          window["my"].unlvideo.toggleScrn(false);
        }
      } catch (e) {

      }
    };
    const videoElement = this.elementRef.nativeElement.querySelector('video');
    if (videoElement) {
      videoElement.muted = true;
      videoElement.volume = 0;
      this.ismuted = true;
    }
  }
  conH() {
    this.conPP = true;
    this.overLayPlay = false;
    this.overLayPause = true;
    setTimeout(() => { if (this.overLayT) this.conPP = false; }, 4000)
  }
  goToNewPage(): void {
    if (!this.add.clickUrl) {
      return;
    }
    window.open(this.add.clickUrl, "_blank");
  }

  closePopup() {
    if (this.add.clickUrl) {
      window.open(this.add.clickUrl, "_blank");
    }
    this.videoPopupService.updateOpenVideoAddSub(false);
  }

  nativeShare() {
    this.ngNavigatorShareService.share({
      title: this.add.customization.Headline,
      text: this.add.customization.Headline,
      url: this.add.clickUrl
    }).then((response) => {
    })
      .catch((error) => {
        console.log(error);
      });
  }
  @HostListener('window:resize', ['$event'])
  applyOrientation() {
    if (window.innerHeight < window.innerWidth) {
      var vid = document.getElementById("vgphome");

      this.isPortrait = false;
    } else if (window.innerHeight > window.innerWidth) {
      this.isPortrait = true;
    }
  }
  setFullScreen(full: boolean): void {
    if (full) {
      if (!this.isFullScreen()) {
        this.toggleFullScreen();
      }
    } else {
      if (this.isFullScreen()) {
        this.toggleFullScreen();
      }
    }
    /*if (full !== this.isFullScreen())
      this.toggleFullScreen();*/
  }
  pauseVG() {
    this.conPP = true;
    this.overLayPause = false;
    this.overLayPlay = true;
    this.api.pause();
  }
  playVG() {
    this.overLayT = true;
    this.conH();
    this.api.play();
  }
  toggleFullScreen(): void {
    const fsDoc = <FsDocument>document;

    if (!this.isFullScreen()) {
      const fsDocElem = <FsDocumentElement>document.getElementById("vgphome");

      if (fsDocElem.requestFullscreen)
        fsDocElem.requestFullscreen();
      else if (fsDocElem.msRequestFullscreen)
        fsDocElem.msRequestFullscreen();
      else if (fsDocElem.mozRequestFullScreen)
        fsDocElem.mozRequestFullScreen();
      else if (fsDocElem.webkitRequestFullscreen)
        fsDocElem.webkitRequestFullscreen();
    } else {
      if (fsDoc.exitFullscreen)
        fsDoc.exitFullscreen();
      else if (fsDoc.msExitFullscreen)
        fsDoc.msExitFullscreen();
      else if (fsDoc.mozCancelFullScreen)
        fsDoc.mozCancelFullScreen();
      else if (fsDoc.webkitExitFullscreen)
        fsDoc.webkitExitFullscreen();
    }
  }
  isFullScreen(): boolean {
    const fsDoc = <FsDocument>document;
    console.log(fsDoc);

    return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
  }


  MuteAudio(event) {
    try {
      var target = event.target || event.srcElement || event.currentTarget;
      console.log("Mutevideoelement");
      var element = target.children[0];
      var vid = <HTMLVideoElement>document.getElementById("popupvideoautoplay");
      if (!this.ismuted) {
        var html = '<div aria-label="mute" class="icon vg-icon-volume_off" role="button" tabindex="0" aria-valuetext="muted"></div>';
        vid.volume = 0;
        vid.muted = true;
        this.ismuted = true;
        target.innerHTML = html;

      } else {
        vid.volume = 1;
        vid.muted = false;
        this.ismuted = false;
        var html = '<div aria-label="mute" class="icon vg-icon-volume_up" role="button" tabindex="0" aria-valuetext="unmuted"></div>';
        target.innerHTML = html;

      }
    } catch (e) {
      alert(e.Message);
    }
  }


  setAutoplay(isMuted: boolean) {
    var vid = <HTMLVideoElement>document.getElementById("popupvideoautoplay");
    if (isMuted) {
      vid.muted = false;
    } else {
      vid.muted = true;
    }
  }
  closePage() {
    this.location.back()
  }

  
  ngAfterViewInit() {
    this.initIntersectionObserver();
  }
  
  private initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };
  
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.playedOnce) {
          const videoElement = entry.target as HTMLVideoElement;
          if (videoElement) {
            // Ensure the video is muted
            videoElement.muted = true;
            videoElement.play();
            this.playedOnce = true;
            this.observer.disconnect();
          }
        }
      });
    }, options);
  
    const videoElement = this.elementRef.nativeElement.querySelector('video');
    if (videoElement) {
      videoElement.setAttribute('muted', 'true');  // Add muted attribute
      videoElement.setAttribute('playsinline', 'true');  // Add playsinline for iOS devices
      this.observer.observe(videoElement);
    }
  }
  
  
  onVideoEnded() {
    console.log('Video has ended');
    this.videoEnded.emit();
  }

}